import React from 'react';
import PropTypes from 'prop-types';
import { Cross, EyeClosed, EyeOpened, Search, sizes } from "../assets";
export var InputButtonIcon = function InputButtonIcon(_ref) {
  var type = _ref.type,
    value = _ref.value,
    clearable = _ref.clearable,
    hidePassword = _ref.hidePassword,
    size = _ref.size;
  var scale = size === 'big' ? 1.15 : 1;
  if (type === 'password' && hidePassword) {
    return /*#__PURE__*/React.createElement(EyeClosed, {
      height: sizes.eyeClosed ? sizes.eyeClosed.height * scale : null,
      width: sizes.eyeClosed ? sizes.eyeClosed.width * scale : null
    });
  } else if (type === 'password' && !hidePassword) {
    return /*#__PURE__*/React.createElement(EyeOpened, {
      height: sizes.eyeClosed ? sizes.eyeClosed.height * scale : null,
      width: sizes.eyeClosed ? sizes.eyeClosed.width * scale : null
    });
  } else if (type === 'search' && !value) {
    return /*#__PURE__*/React.createElement(Search, {
      height: sizes.search ? sizes.search.height * scale : null,
      width: sizes.search ? sizes.search.width * scale : null
    });
  } else if (value && (type === 'search' || clearable)) {
    return /*#__PURE__*/React.createElement(Cross, {
      height: sizes.cross ? sizes.cross.height * scale : null,
      width: sizes.cross ? sizes.cross.width * scale : null
    });
  }
  return null;
};
InputButtonIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clearable: PropTypes.bool,
  hidePassword: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big'])
} : {};
InputButtonIcon.defaultProps = {
  type: 'text',
  value: '',
  clearable: false,
  hidePassword: false,
  size: 'default'
};